<template>
  <div class="recommend-detail-base" :style="styles">
    <div class="head-block">
      <div class="recommend-img-wrap" :class="{noimage: !recommendInfo.pack_image || recommendInfo.pack_image.length <= 0}" >
        <img class="recommend-image"
             :src="recommendInfo.pack_image"
             :alt="recommendInfo.item_name"
             @error="onImgLoadError"
        >
      </div>
      <h1 :class="{result: isResult}">{{recommendInfo.item_name}}</h1>
      <p class="result-description" v-html="recommendInfo.item_description" v-if="isResult"></p>
      <div class="recommend-info" v-if="!isResult">
        <p class="description" v-html="recommendInfo.item_description"></p>
        <span class="price" v-if="itemPrice != null">￥{{ itemPrice }}<span v-if="itemPrice > 0" class="tax-in">（税込）</span></span>
        <sec-button-link
          :button-face="recommendInfo.button_text"
          :btn-disable="recommendInfo.sales_invalid"
          :no-border="true"
          :link-url="`/recommend/${recommendInfo.id}/profile`"
          :check-through="true"
        />
      </div>
    </div>
    <div class="result-list" v-if="isResult">
      <template v-for="(item, index) in menuList">
        <result-list
          :item-data="item"
          :key="index"
          :no-fav="true"
          :force-disable-tag-link="true"
          :scrollClass="'.result-list'"
          :scroll-tgt-is-window="true"
          @open-item="onItemClick"
        />
      </template>
    </div>
    <div class="menus-list" v-else>
      <div class="notice"> 備考<br>・サブスクリプションにお申込み済みの方は、サブスクリプション内で占えるものと同一のメニューになります。購入せず、ログインして画面左側「さがす」から検索してご覧ください。<br>・本商品で占うことが可能な生年月日は、1940年1月1日以降の方です。<br>・一部の文章に男性向け・女性向けの表現が含まれる場合がございますが、占いの内容は性別に関係なく適応されます。<br></div>
    </div>
    <template v-if="showBottomInfo">
      <block-uranai-tv-short
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :subsc-url="subscUrl"
        :lp-id="lpId"
        :menu-id="myMenuId"
        page="result"
        :no-deco="true"
        :is-individualed="true"
      />
      <block-menus
        :lp-id="lpId"
        v-if="menusList.length"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :menu-list="menusList"
        :tab-list="menusTabList"
        :ga-event-categ="`LP${lpId}result-paid-content-button`"
        page="result"
      />
      <div class="subscr-base bottom">
        <go-uranai-tv
          :color-scheme="colorScheme"
          :ga-event-categ="`LP${lpId}result-subsc-button`"
          :ga-event-label="`${myMenuId}`"
          :subsc-url="subscUrl"
          :menu-id="myMenuId"
          :upper-caption="targetInfo.uTV.resultBottomCap"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MENU_ITEM_TYPE } from '@/CONSTS/MENUS'
import { BASIC_DATA } from '@/utvStore/components/recommend/lp/commons'
import * as type from '@/utvStore/store/mutation-types'
import TagList from '@/utvStore/components/partials/TagList'
import ResultList from '@/utvStore/components/recommend/ResultList'
import SecButtonLink from '@/utvStore/components/partials/SecButtonLink'
import BlockUranaiTvShort from '@/utvStore/components/recommend/lp/blocks/BlockUranaiTvShort'
import BlockMenus from '@/utvStore/components/recommend/lp/blocks/BlockMenus'
import GoUranaiTv from '@/utvStore/components/recommend/lp/partials/GoUranaiTv'

export default {
  name: 'RecommendDetail',
  components: {
    GoUranaiTv,
    SecButtonLink,
    TagList,
    ResultList,
    BlockUranaiTvShort,
    BlockMenus,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menuId: {
      type: Number,
      default: 0,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    recommendInfoReceive: {
      type: Object,
      default(){
        return {
          id: 0,
          item_name: '',
          item_description: '',
          pack_image: '',
          price_taxin: 0,
          menu_list: [],
        }
      }
    },
    isResult: {
      type: Boolean,
      default: false,
    },
    subscUrl:{
      type: String,
      default: '/'
    },
  },
  data(){
    return {
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    myMenuId(){
      const mtc = location.pathname.match(/\/recommend\/(\d+)\//)
      return this.menuId > 0 ? this.menuId : +mtc[1]
    },
    showBottomInfo() {
      const A = /\/recommend\/\d+\/result/.test(location.pathname)
      const B = this.lpId != 6 // そまり百音さん（lpId == 6）は、月額メニューが少ないので一旦対象外
      return A && B
    },
    targetInfo(){
      switch (this.lpId) {
        case 1: return BASIC_DATA.kurenotori.information
        case 2: return BASIC_DATA.kanoucoco.information
        case 3: return BASIC_DATA.touwa.information
        case 4: return BASIC_DATA.houen.information
        case 5: return BASIC_DATA.ottimo.information
        case 6: return BASIC_DATA.somarimone.information
      }
    },
    colorScheme(){
      switch (this.lpId) {
        case 1: return BASIC_DATA.kurenotori.colorScheme
        case 2: return BASIC_DATA.kanoucoco.colorScheme
        case 3: return BASIC_DATA.touwa.colorScheme
        case 4: return BASIC_DATA.houen.colorScheme
        case 5: return BASIC_DATA.ottimo.colorScheme
        case 6: return BASIC_DATA.somarimone.colorScheme
      }
    },
    itemPrice(){
      return this.recommendInfo.price_taxin != null ? this.recommendInfo.price_taxin.toLocaleString() : null
    },
    recommendInfo(){
      const rcv = this.recommendInfoReceive
      return {
        id: rcv.id,
        item_name: rcv.item_name,
        item_description: rcv.item_description,
        pack_image: rcv.pack_image,
        price_taxin: rcv.price_taxin,
        sales_invalid: !(+rcv.sales_invalid === 0 || !rcv.sales_invalid || (typeof rcv.sales_invalid === 'string' && rcv.sales_invalid.toLowerCase() === 'false')),
        button_text: rcv.free_flg === 0 ? "購入する" : "無料で占う"
      }
    },
    menuList(){
      const rtn = []
      const lst = this.recommendInfoReceive.menu_list
      if(lst.length <= 0) return
      for(let item of lst){
        const modtg = []
        if(!!item.tags) {
          item.tags.forEach(tg => {
            modtg.push({
              id: +tg.id,
              tagName: tg.tagName,
            })
          })
        }
        const counselor = {}
        if(!!item.counselor){
          counselor.id = item.counselor.id
          counselor.name = item.counselor.name
          counselor.thumbnail = item.counselor.thumbnail
        }
        rtn.push({
          id: item.id,
          name: item.title,
          itemType: MENU_ITEM_TYPE.text,
          result: {
            text: item.text,
          },
          counselor: {...counselor},
          tags: [...modtg]
        })
      }
      return rtn
    },
    styles(){
      return {
        '--result-menus-bg': !!this.targetInfo.menuDetails.colors.resultBg ? this.targetInfo.menuDetails.colors.resultBg : 'white',
      }
    },
  },
  methods: {
    onImgLoadError(e) {
      e.target.parentElement.classList.add('noimage')
    },
    onItemClick(val){
      this.$store.dispatch(type.SET_TEXT_DETAIL_OPEN, +val)
    },
  },
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

$l_col_result_menus_bg: var(--result-menus-bg);
.recommend-detail-base {
  width: 100%;
  .head-block {
    width: 100%;
    h1 {
      color: $col_base_black;
      padding: 24px 20px 20px;
      font-size: 17px;
      line-height: 21px;
      margin: 0;
    }
    .recommend-img-wrap {
      width: 100%;
      &.noimage {
        display: none;
      }
      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
    .recommend-info {
      width: 100%;
      padding: 0 20px;
      margin-bottom: 17px;
      .price {
        color: #ed1e79;
        font-size: 18px;
        display: block;
        width: 100%;
        text-align: right;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 20px;
        .tax-in {
          font-size: 10px;
          margin-left: -2px;
          display: inline-block;
          padding-bottom: 2px;
          vertical-align: bottom;
        }
      }
      .description {
        color: $col_temp_gray6;
        margin: 0 0 15px;
        font-size: 13px;
        line-height: 21px;
      }
      .attention {
        margin: 0 0 4px;
        font-size: 11px;
        color: $col_base_black;
      }
      /deep/ .button-link-base {
        width: 100%;
        padding: 0 10px 10px;
        .button-link {
          width: 100%;
        }
      }
    }
    .result-description {
      color: $col_temp_gray6;
      margin: 0;
      padding: 0 20px;
      font-size: 13px;
      line-height: 21px;
      border-bottom: 1px solid $col_temp_gray3;
    }
  }
  .menus-list {
    h2 {
      color: $col_base_black;
      font-size: 12px;
      font-weight: bold;
      width: 100%;
      margin: 0;
      padding: 10px 8px 10px 20px;
      line-height: 1;
      background: linear-gradient(86.53deg, #FFF3F5 21.4%, #F9F4FD 76.64%);
    }
    .notice {
      font-size: 13px;
      line-height: 21px;
      padding: 25px 20px 70px;
      color: $col_base_black;
    }
  }
  .result-list {
    //padding-bottom: 300px;
    /deep/ .tag-list-base {
      color: $col_normal_font;
      padding: 3px 0 0;
      line-height: 10px;
    }
  }
  /deep/ .block-uranaitv-base {
    background: $l_col_result_menus_bg;
  }
  .subscr-base {
    &.bottom {
      background: white;
      padding: 40px 0 60px;;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/RecommendDetail.vue